import React, { useEffect, useState, useRef } from "react";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import { error, openNotification, success, warning } from "swfrontend/COMS/NotificationMessageMapping";
import ListFooter from "swfrontend/MDM/MDMScreens/ListView/ListFooter.js";
import { localStorageVariableName, route_url } from "swfrontend/AppConfigs";
import {
  notificationMessage,
  openNotificationType,
  notificationTitle,
} from "swfrontend/MDM/MDMUIConfigs/MDMUIMappings";
import ListHeader from "./Components/ListHeader";
import MaterialListCellButton from "./Components/MaterialListCellButton";
import dayjs from "dayjs";

import { DataProvider } from "../../DataProvider";
import {ALL_CLAIM_COLUMN_DEFS} from "../../Constants";

let gridApi = null;
const dataProvider = new DataProvider();
const loggedinUser = localStorage.getItem(localStorageVariableName.userName);
const onFirstDataRendered = (params) => params.api.sizeColumnsToFit();
const onGridReady = (params) => {
  gridApi = params.api;
};




const AllClaims = ({history}) => {
  const gridRef = useRef(null);
  const [rowData, setRowData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null)
  const [total, setTotal] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)
  const [filterQuery, setFilterQuery] = useState(null)
  const [searchQuery, setSearchQuery] = useState(null)
  const [selectedStatus, setSelectedStatus] = useState("ALL");
  const [isSupplier, setSupplier] = useState(true)
  
  const STATUSES = ["ALL", "OPEN", "RESPONDED", "SETTLED", "REFUTED"];

  const fetchGridData = () => {
    let query = null;
    if (searchQuery && filterQuery) {
      query = {"search": searchQuery, "filter": filterQuery, "page":currentPage, "pageSize":pageSize}
    }
    else if (searchQuery) {
      query = `page=${currentPage}&pageSize=${pageSize}&search=${searchQuery}`
    }
    else if (filterQuery) {
      query = {"filter": filterQuery, "page":currentPage, "pageSize":pageSize}
    }
    else {
      query = `page=${currentPage}&pageSize=${pageSize}`
    }
    query = query + `&status=${selectedStatus}`
    dataProvider.getContractValuesforDropdown(query)
      .then((res) => {
        if (res.ok) {
          res.json().then((data) => {
            setSupplier(data["is_supplier"])
            setTotal(data?.["count"]? data?.["count"] : data?.["total"])
            
            const row_data = data["results"].map((row) => {
              row["contract_date"] = dayjs(row["contract_date"]).format("YYYY-MM-DD")
              row["contract_start_date"] = dayjs(row["contract_start_date"]).format("YYYY-MM-DD")
              row["contract_end_date"] = dayjs(row["contract_end_date"]).format("YYYY-MM-DD")
              row["status"] = row["status"].toUpperCase()
              row["contract_project"] = row["contract_project"]?.["project_id"] ? row["contract_project"]?.["project_id"] : row["contract_project"]

              return row;
            });
            setRowData(row_data);
            setSelectedRow(row_data)

          });
            }
        else {
          res.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch(() => {
        openNotification(
          openNotificationType.error,
          notificationTitle.api,
          notificationMessage.apiConnectionError
        );
      });
  };

  const fetchStatusWiseData = (status) => {
    if (status === "all") {
      setSelectedRow(rowData);
      return;
    }
    dataProvider.getContractDataBasedOnStatus(status)
      .then((res) => {
        if (res.ok) {
          res.json().then((data) => {
            setSupplier(data["is_supplier"])
            setTotal(data["count"])
            setSelectedRow(rowData.filter((item) => data["results"].includes(item.id) ));
          });
            }
        else {
          res.json().then((responseJson) => {
            openNotification("error", "Error", responseJson["message"]);
          });
        }
      })
      .catch(() => {
        openNotification(
          openNotificationType.error,
          notificationTitle.api,
          notificationMessage.apiConnectionError
        );
      });
  };


  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    fetchStatusWiseData(status.toLowerCase())

  };


  const onSelectionChanged = () => {
   
  };

  const handleSearchApply = (value) => {
    gridApi.showLoadingOverlay();

    if (value === "") {
      setSearchQuery(null)
    }

    setSearchQuery(value)
    setCurrentPage(1)
  }

  const handleFilterApply = (queryString) => {
    gridApi.showLoadingOverlay();
    setFilterQuery(queryString)
    setCurrentPage(1)
    
  }

  const handleResetSearch = () => {
    gridApi.showLoadingOverlay();
    setSearchQuery(null)
  }

  const handleResetFilter = () => {
    gridApi.showLoadingOverlay();
    setFilterQuery(null)
    setCurrentPage(1)
  }
  
  const onPaginationChange = (page, pageSize) => {
    if (page === 0 || page === null) {
      page = 1;
    }
    gridApi.showLoadingOverlay();
    setPageSize(pageSize)
    setCurrentPage(page)
  };

  const cellLinkButtonClick = (e) => {
    const row = e?.id || e.data.id;
    const data = e?.id ? e : e.data;

      history.push({
        pathname: `${route_url.url}/ViewClaim/${row}`,
        state: { contractData: data }
    });
    };

  const handleNewButtonClick = () => {
        history.push(route_url.url + '/NewClaim/');
      };

  useEffect(() =>{
    fetchGridData()
      }, [searchQuery, currentPage, pageSize]);


  let gridHeight = window.innerHeight - 400 + "px";
  ALL_CLAIM_COLUMN_DEFS.map((column, index) => {
    if (["id"].includes(column.field)) {
            column['cellRendererParams'] = { cellLinkButtonClick: cellLinkButtonClick }
    }
  });

  let grid = (
      <AgGridReact
        ref={gridRef}
        columnDefs={ALL_CLAIM_COLUMN_DEFS}
        rowData={selectedRow}
        pagination={false}
        onGridReady={onGridReady}
        onFirstDataRendered={onFirstDataRendered}
        onSelectionChanged={onSelectionChanged}
        onRowDoubleClicked={cellLinkButtonClick}
        frameworkComponents={{
                MaterialListCellButton,
              }}     
      ></AgGridReact>
      );
 

  return (
    <div className="col-md-12">

      <ListHeader
              showListHeader={true}
              addButton={isSupplier}
              addFilters={true}
              addAction={true}
              columnFilterButton={false}
              columnDefs={[]}
              onSearch={(q) => handleSearchApply(q)}
              onFilter={(q) => handleFilterApply(q)}
              onResetSearch={() => handleResetSearch()}
              onResetFilter={() => handleResetFilter()}
              addField={handleNewButtonClick}
              status = {STATUSES}
              getStatusWiseData = {handleStatusChange}
            />
      <div className="grid-background">
        <div className="row">
          <div className="col-md-12">
            <div
              id="grid"
              className="table-responsive table-bordered table table-hover table-bordered results ag-theme-balham gridViewDisplay"
              style={{ height: gridHeight }}
            >
              {grid}
            </div>
          </div>
        </div>
      </div>
      <div>
        <ListFooter
                total={total}
                currentPage={currentPage}
                onShowSizeChange={(pageNo, pageSize) =>
                  onPaginationChange(pageNo, pageSize)
                }
                onPaginationChange={(pageNo, pageSize) =>
                  onPaginationChange(pageNo, pageSize)
                }
          />
        </div>
      
    </div>
  );
};

export default AllClaims;
